<button (mouseenter)="buttonEnter()" (mouseleave)="buttonLeave()" (touchstart)="buttonTouch()">
  @if (data.icon) {
    <ui-icon [faName]="data.icon" faStyle="light"></ui-icon>
  }
  <span>{{ data.name }}</span>
</button>

<div [matMenuTriggerFor]="menu"></div>

<mat-menu #menu="matMenu" [hasBackdrop]="false">
  @for (item of data.items; track item) {
    @if (!useRouterLinks || item.target === '_blank') {
      <ng-container
        [ngTemplateOutlet]="hrefContent"
        [ngTemplateOutletContext]="{ item }">
      </ng-container>
    }
    @if (useRouterLinks && item.target !== '_blank') {
      <ng-container
        [ngTemplateOutlet]="routerLinkContent"
        [ngTemplateOutletContext]="{ item }">
      </ng-container>
    }
  }
</mat-menu>

<ng-template #routerLinkContent let-item="item">
  <a [routerLink]="item.url" target="_self"
     [disabled]="!!item.disabled" mat-menu-item>
    <ng-container [ngTemplateOutlet]="linkContent" [ngTemplateOutletContext]="{ item }"></ng-container>
  </a>
</ng-template>

<ng-template #hrefContent let-item="item">
  <a [href]="item.url" [target]="item.target" [disabled]="!!item.disabled"
     mat-menu-item>
    <ng-container [ngTemplateOutlet]="linkContent" [ngTemplateOutletContext]="{ item }"></ng-container>
  </a>
</ng-template>

<ng-template #linkContent let-item="item">
  @if (item.icon && item.icon !== 'quick-order') {
    <ui-icon [faName]="item.icon" faStyle="light"></ui-icon>
  }
  @if (item.icon === 'quick-order') {
    <ui-icon [faName]="item.icon" class="custom" faStyle="custom"></ui-icon>
  }
  <span>{{ item.label }}</span>
</ng-template>
